import {
  Card,
  CardContent,
  CardHeader,
  ControlLabel,
  Divider,
  Stack,
  Switch,
  Tag,
  Typography,
} from '@all-manager/design-system-v2';
import { AI_FEATURES, useAiSettingsCard } from './useAiSettingsCard';

type Props = {
  spaceId: string;
};

export default function AiSettingsCard(props: Props) {
  const hook = useAiSettingsCard(props);

  return (
    <Card>
      <CardHeader
        title="Intelligence artificielle"
        subheader="Un seul réglage pour toute la copropriété."
        action={(
          <ControlLabel
            control={(
              <Switch
                color="ai"
                checked={hook.isAiEnabled}
                onChange={hook.handleToggle}
                disabled={hook.isDisabled}
              />
            )}
            label={hook.statusLabel}
          />
        )}
      />
      <CardContent>
        <Stack spacing={2}>
          <Stack spacing={2} divider={<Divider />}>
            {AI_FEATURES.map((feature) => (
              <Stack
                key={feature.id}
                direction="row"
                spacing={2}
                alignItems="flex-start"
                justifyContent="space-between"
              >
                <Stack spacing={0.5}>
                  <Typography variant="body1Emphasis">{feature.title}</Typography>
                  <Typography variant="body2">{feature.description}</Typography>
                </Stack>
                <Tag color={hook.featureStateColor} variantIcon="state" label={hook.getFeatureStateLabel(feature)} />
              </Stack>
            ))}
          </Stack>
          <Typography variant="body2">{hook.dataNotice}</Typography>
        </Stack>
      </CardContent>
    </Card>
  );
}
